module.exports = __webpack_public_path__ + "static/media/payment-pix.ce898726.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/payment-pix.svg
// module id = 2897
// module chunks = 0